import React from 'react';
import { Modal, Box, DialogTitle, IconButton, Button } from '@mui/material';
import { X, Upload } from 'lucide-react';

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  p: 0,
};

const UploadModal = ({ open, onClose, onFileChange, onUpload }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="upload-modal-title"
      aria-describedby="upload-modal-description"
    >
      <Box sx={modalStyle}>
        <DialogTitle
          sx={{
            p: 2,
            fontSize: 18,
            fontWeight: 500,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Upload CSV
          <IconButton onClick={onClose} size="small" sx={{ color: "text.secondary" }}>
            <X size={20} />
          </IconButton>
        </DialogTitle>
        <Box sx={{ p: 2 }}>
          <input type="file" accept=".csv" onChange={onFileChange} />
        </Box>
        <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              bgcolor: "#e0e0e0",
              color: "#000",
              "&:hover": { bgcolor: "#d5d5d5" },
              textTransform: "none",
              borderRadius: 2,
              fontWeight: 600,
              px: 3,
              fontSize: "16px",
              lineHeight: "24px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onUpload}
            variant="contained"
            startIcon={<Upload size={18} />}
            sx={{
              bgcolor: "#00694B",
              color: "#fff",
              "&:hover": { bgcolor: "#005039" },
              textTransform: "none",
              borderRadius: 2,
              fontWeight: 600,
              px: 3,
              fontSize: "16px",
              lineHeight: "24px",
            }}
          >
            Upload
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UploadModal;